import axios, { AxiosInstance } from "axios";

class AxiosService {
  service: AxiosInstance;

  constructor() {
    this.service = axios.create();
  }

  async get(path) {
    return await this.service.get(path);
  }

  async patch(path, payload) {
    return await this.service.request({
      method: "PATCH",
      url: path,
      responseType: "json",
      data: payload,
    });
  }

  async post(path, payload) {
    const { data, status } = await this.service.request({
      method: "POST",
      url: path,
      responseType: "json",
      data: payload,
    });

    return { data, status };
  }
}

export default new AxiosService();
